import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import { useAuthContext } from "./AuthContext";
import { getSocketWorkspace } from "../utils/socketWorkspace";
import { SOCKET_SERVER_URL } from "../constants/socketServer";
import { buildTeamPresenceXpro4Payload } from "../utils/teamPresenceTelemetry";
import { clearMainAppPresenceSocketMergeCache } from "../utils/teamPresenceUsersSocket";

const SOCKET_URL = SOCKET_SERVER_URL;
const SocketContext = createContext();

export const useSocketContext = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const { bearerToken, userData } = useAuthContext();
  const [socketInstance, setSocketInstance] = useState(null);

  useEffect(() => {
    if (bearerToken && userData) {
      if (!socketRef.current) {
        const socket = io(SOCKET_URL, {
          transports: ["websocket"],
          auth: { token: bearerToken },
        });

        const company = localStorage.getItem("company");

        socket.on("connect", () => {
          const workspace = getSocketWorkspace() || (company ? `${company}.xpro.me` : "");
          const base = {
            id: userData.id,
            name: userData.nome,
            workspace,
          };
          socket.emit("newUser", base);
          // Mesmo contrato da tela administrar/usuarios (legado): lista presença e abas por workspace
          socket.emit("users", buildTeamPresenceXpro4Payload(base));
        });

        socket.on("connect_error", (error) => {
          console.error("Erro de conexão ao WebSocket:", error);
        });

        socket.on("disconnect", (reason) => {
          // console.log("Desconectado do WebSocket:", reason);
        });

        socketRef.current = socket;
        setSocketInstance(socket);
      }
    }

    return () => {
      if (socketRef.current) {
        clearMainAppPresenceSocketMergeCache();
        socketRef.current.disconnect();
        socketRef.current = null;
        setSocketInstance(null);
      }
    };
  }, [bearerToken, userData]);

  const emit = (event, data) => {
    socketRef.current?.emit(event, data);
  };

  const on = (event, callback) => {
    socketRef.current?.on(event, callback);
  };

  const off = (event, callback) => {
    socketRef.current?.off(event, callback);
  };

  return (
    <SocketContext.Provider value={{ socket: socketInstance, emit, on, off }}>
      {children}
    </SocketContext.Provider>
  );
};
